import PropTypes from 'prop-types'
import styled from 'styled-components'
import { border as borderColors } from 'theme/palette'
import { borderWidth, opacity } from 'theme/globals'

const StyledDivider = styled.div.withConfig({
  shouldForwardProp: prop => ![
    'variant',
    'color',
    'height',
    'vertical',
    'thickness',
    'width',
    'blend',
    'active',
  ].includes(prop),
})`
  ${props =>
    props.variant === 'dashed'
      ? `
    border-bottom: 1px dashed ${props.theme.palette.border[props.color]};
  `
      : `
    background-color: ${props.theme.palette.border[props.color]};
    height: ${
      props.height
        ? props.height
        : props.vertical
        ? '100%'
        : `${props.theme.globals.borderWidth[props.thickness]}`
    };
    width: ${
      props.width
        ? props.width
        : props.vertical
        ? `${props.theme.globals.borderWidth[props.thickness]}`
        : '100%'
    };
    margin-left: auto;
    margin-right: auto;
  `}
  ${props => props.blend ? `opacity: ${['string', 'number'].includes(typeof props.blend) ? props.theme.globals.opacity[props.blend] : props.theme.globals.opacity.main};` : ``}
`

const Divider = props => <StyledDivider {...props} />

Divider.propTypes = {
  thickness: PropTypes.oneOf(Object.keys(borderWidth)),
  color: PropTypes.oneOf(Object.keys(borderColors)),
  vertical: PropTypes.bool,
  width: PropTypes.string,
  height: PropTypes.string,
  variant: PropTypes.oneOf(['solid', 'dashed']),
  blend: PropTypes.oneOf([true, false, ...Object.keys(opacity)]),
}

Divider.defaultProps = {
  thickness: 'main',
  color: 'neutral_500',
  vertical: false,
  variant: 'solid',
}

export default Divider
